<template>
    <div ref="routeContainer" style="position: relative">
        <div class="tutorial-container-routes" v-if="showTutorial">
            <div class="tutorial-content col-md-4 col-sm-6">
                <div class="card tutorial-card">
                    <div class="card-header text-end">
                        <button
                            class="btn btn-link text-white"
                            @click="closeTutorial"
                        >
                            <i class="fa fa-xmark"></i>
                        </button>
                    </div>
                    <div class="card-body">
                        <h3 class="text-white">
                            ¿Cómo crear una ruta de aprendizaje?
                        </h3>
                        <span
                            >Define metas educativas. Navega a 'Aprendizaje',
                            sigue los 4 sencillos pasos para la generación de tu
                            ruta y asigna a tu equipo.</span
                        >
                    </div>
                    <div
                        class="card-footer d-flex justify-content-end pb-3 pe-5 pt-2"
                    >
                        <a
                            href="#"
                            @click.prevent="openTutorialVideo"
                            class="text-end text-white"
                        >
                            Ver tutorial
                            <i class="fa ms-2 fa-arrow-right text-white"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="bg-white p-5 mb-3 rounded">
            <div class="row p-3 rounded-8" style="background-color: #f8f8f8">
                <div class="col-md-4 min-h-100">
                    <stepper :activeStep="step"></stepper>
                </div>
                <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
                    <Introduction
                        v-if="step === STEPS.INTRODUCTION"
                        @changeStep="changeStep"
                    />
                    <RouteInformation
                        v-if="step === STEPS.INFORMATION"
                        :info="info"
                        :client="client"
                        @changeStep="changeStep"
                        @setRuta="setInfo"
                        :url_get_route_validation="url_get_route_validation"
                    />
                    <RouteCourses
                        v-if="step === STEPS.COURSES"
                        :info="info"
                        :url_courses_wp="url_courses_wp"
                        @changeStep="changeStep"
                        @setRuta="setInfo"
                    />
                    <RouteUsers
                        v-if="step === STEPS.USERS"
                        :url_get_students="url_get_students"
                        :url_custom_routes="url_custom_routes"
                        :url_get_companies="url_get_companies"
                        :info="info"
                        :empresa_elegida="empresaSelected"
                        @changeStep="changeStep"
                        @setRuta="setInfo"
                        @recargaTable="reloadTable"
                    />
                    <RouteConfirmation
                        v-if="step === STEPS.CONFIRMATION"
                        :info="info"
                        @changeStep="changeStep"
                        @setRuta="setInfo"
                    />
                </div>
            </div>
        </div>

        <ModalVideo
            url="https://www.youtube.com/embed/7eNilg2F4A0?si=_SqWLdVClCLZf-hU"
            v-if="openVideoModal"
            @onClose="openVideoModal = false"
        />
    </div>
</template>

<script>
import Introduction from "./customRouteSteps/createCustomRouteIntroduction.vue";
import RouteInformation from "./customRouteSteps/createCustomRouteInformation.vue";
import RouteCourses from "./customRouteSteps/createCustomRouteCourses.vue";
import RouteUsers from "./customRouteSteps/createCustomRouteInfoUsers.vue";
import RouteConfirmation from "./customRouteSteps/createCustomRouteConfirmation.vue";
import Stepper from "./customRouteSteps/createCustomRouteStepper.vue";
import ModalVideo from "../tutorials/ModalTutorial.vue";
import { useTutorial } from "../../composables/useTutorial.js";

const STEPS = {
    INTRODUCTION: 0,
    INFORMATION: 1,
    COURSES: 2,
    USERS: 3,
    CONFIRMATION: 4,
};

const STEP_TRANSITION_DELAY = 750; // Delay para animación del paso de usuarios
const TUTORIAL_ID = 'routes-createroute';

const createEmptyRouteInfo = () => ({
    name: "",
    description: "",
    type_period: "",
    validity_time: "",
    courses: [],
    students: [],
    parentId: 0,
});

export default {
    name: 'CreateCustomRoute',
    components: {
        Introduction,
        RouteInformation,
        RouteCourses,
        RouteUsers,
        RouteConfirmation,
        Stepper,
        ModalVideo,
    },
    props: {
        url_courses_wp: { type: String, required: true },
        url_get_students: { type: String, required: true },
        url_get_companies: { type: String, required: true },
        url_custom_routes: { type: String, required: true },
        url_get_route_validation: { type: String, required: true },
        client: { type: [Object, String], default: null },
    },
    data() {
        return {
            STEPS,
            step: STEPS.INTRODUCTION,
            info: createEmptyRouteInfo(),
            empresaSelected: "",
            showTutorial: false,
            openVideoModal: false,
        };
    },
    mounted() {
        const { isShowed } = useTutorial(TUTORIAL_ID);
        this.showTutorial = !isShowed();
    },
    methods: {
        changeStep(newStep) {
            this.scrollToTop();
            
            // Delay para animación cuando se va al paso de usuarios
            if (newStep === STEPS.USERS) {
                setTimeout(() => {
                    this.step = newStep;
                }, STEP_TRANSITION_DELAY);
            } else {
                this.step = newStep;
            }
        },
        scrollToTop() {
            this.$refs.routeContainer?.scrollIntoView({ behavior: 'smooth' });
        },
        setInfo(route) {
            this.info = route;
        },
        reloadTable(reload) {
            this.$emit("recargaTable", reload);
        },
        closeTutorial() {
            const { markAsShowed } = useTutorial(TUTORIAL_ID);
            markAsShowed();
            this.showTutorial = false;
        },
        openTutorialVideo() {
            this.closeTutorial();
            this.openVideoModal = true;
        },
    },
};
</script>

<style scoped>
.bg-grey {
    background-color: #cbb9ff66;
}

.step-default {
    background-color: #cbb9ff99;
    color: #9164ff;
}

.step-active {
    background-color: #d537ed;
    color: #1a0054;
}

.step-done {
    background-color: #da89e8cc;
    color: #1a0054;
}

.line-default {
    border-left: 10px solid #cbb9ff99;
    height: 40px;
    display: inline-block;
}

.line-active {
    border-left: 10px solid #d537ed;
    height: 40px;
    display: inline-block;
}

.line-done {
    border-left: 10px solid #da89e8cc;
    height: 40px;
    display: inline-block;
}

.tutorial-card {
    background-color: #4000bc;
    color: #fff;
    text-align: left;
}

.tutorial-card .card-header,
.tutorial-card .card-footer {
    border: none;
    background-color: inherit;
}

.tutorial-container-routes {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    z-index: 10000;
}

.tutorial-container-routes .tutorial-content {
    margin-right: 5%;
}

@media (max-width: 576px) {
    .tutorial-container-routes .tutorial-content {
        margin-right: 0;
    }
}
</style>
